// Loads the Base44 SDK (and its axios / realtime-socket code) on demand, so it is NOT part of the
// first download for visitors. Public pages call getBase44() only when they actually need it
// (a form is submitted, the blog loads posts, staff log in).
//
// The realtime socket inside the SDK only connects when a page subscribes to live updates,
// which no public page does — so visitors never open a socket connection.
let sdkPromise = null;

export function getBase44() {
  if (!sdkPromise) {
    sdkPromise = import('./base44Client').then((m) => m.base44);
    // If the download fails (e.g. flaky mobile signal) allow a retry next time.
    sdkPromise.catch(() => { sdkPromise = null; });
  }
  return sdkPromise;
}

// Warm the SDK up once the first content has painted and the phone is idle, so Base44's own
// visitor analytics keep working and forms respond instantly — without slowing the first screen.
export function loadBase44WhenIdle() {
  if (typeof window === 'undefined') return;
  const warm = () => { getBase44().catch(() => {}); };
  const whenIdle = () => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 5000 });
    else setTimeout(warm, 2000);
  };
  afterFirstPaint(whenIdle);
}

// Runs fn after the page has loaded AND painted its first content (helper defined in index.html).
export function afterFirstPaint(fn) {
  if (typeof window !== 'undefined' && typeof window.afterFirstPaint === 'function') window.afterFirstPaint(fn);
  else if (typeof window !== 'undefined') window.addEventListener('load', () => setTimeout(fn, 0), { once: true });
}
